import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyBJ-CgXDpNfbel8733bCBcv_RN92VPU19s",
    authDomain: "myhangul.firebaseapp.com",
    databaseURL: "https://myhangul.firebaseio.com",
    projectId: "myhangul",
    storageBucket: "myhangul.appspot.com",
    messagingSenderId: "961954674896",
};
firebase.initializeApp(config);

const databaseRef = firebase.firestore();

export const DearRef = databaseRef.collection('dear-app');
